import {createStorage} from '/util/async-storage';

export const {
  setValue: setTestingDate,
  getValue: getTestingDate,
  clearValue: clearTestingDate,
} = createStorage({key: 'testing-date'});

export const {
  setValue: setTestingOpenPeriodId,
  getValue: getTestingOpenPeriodId,
  clearValue: clearTestingOpenPeriodId,
} = createStorage({key: 'testing-open-period'});

export const {
  setValue: setTestingCurrentPeriodId,
  getValue: getTestingCurrentPeriodId,
  clearValue: clearTestingCurrentPeriodId,
} = createStorage({key: 'testing-current-period'});

export const {
  setValue: setTestingLatestAcceptedPeriodId,
  getValue: getTestingLatestAcceptedPeriodId,
  clearValue: clearTestingLatestAcceptedPeriodId,
} = createStorage({key: 'testing-latest-accepted-period'});

export const {
  setValue: setTestingLastPeriodId,
  getValue: getTestingLastPeriodId,
  clearValue: clearTestingLastPeriodId,
} = createStorage({key: 'testing-last-period'});
